/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "De hub voor vriendschap",
      "Vind nieuwe vrienden met de app Bumble For Friends | Bumble",
      "Downloaden via de App Store",
      "Downloaden via Google Play",
      "Een plek om nieuwe vrienden te maken",
      "Ontdek mensen in de buurt om een nieuwe vriendschap mee te sluiten.",
      "Vind vrienden voor elke levensfase",
      "Ben je verhuisd? Wil je een nieuw begin? Je nieuwe vriendengroep wacht op je!",
      "Een veilige plek voor iedereen",
      "Welkom bij een leuk stukje van het internet, waar jij jezelf mag zijn.",
      "Download de app",
      "Spreek IRL af met mensen met dezelfde interesses.",
      "Leer een nieuwe groep mensen kennen met Plans op Bumble For Friends",
      "Je bent uitgenodigd voor Plans",
      "Plans is een nieuwe functie in Bumble For Friends. Je kunt je hier aansluiten bij een groep of je eigen groep maken met nieuwe vrienden bij jou in de buurt.",
      "Cookies beheren",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dagen"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "uur"
            ],
            "singular": [
                  "uur"
            ]
      },
      "minute": {
            "plural": [
                  "minuten"
            ],
            "singular": [
                  "minuut"
            ]
      },
      "month": {
            "plural": [
                  "maanden"
            ],
            "singular": [
                  "maand"
            ]
      },
      "second": {
            "plural": [
                  "seconden"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "jaar"
            ],
            "singular": [
                  "jaar"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
